import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "max-w-lg flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md" }
const _hoisted_2 = {
  key: 0,
  class: "text-center"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  class: "mx-auto h-10 w-10 text-gray-400",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M6 12h10v1h-10v-1zm7.816-3h-7.816v1h9.047c-.45-.283-.863-.618-1.231-1zm5.184 1.975v2.569c0 4.106-6 2.456-6 2.456s1.518 6-2.638 6h-7.362v-20h9.5c.312-.749.763-1.424 1.316-2h-12.816v24h10.189c3.163 0 9.811-7.223 9.811-9.614v-3.886c-.623.26-1.297.421-2 .475zm-13-3.975h6.5c-.134-.32-.237-.656-.319-1h-6.181v1zm17-2.5c0 2.485-2.017 4.5-4.5 4.5s-4.5-2.015-4.5-4.5 2.017-4.5 4.5-4.5 4.5 2.015 4.5 4.5zm-2-.5h-2v-2h-1v2h-2v1h2v2h1v-2h2v-1z" })
], -1)
const _hoisted_4 = { class: "space-y-1 mt-2" }
const _hoisted_5 = { class: "text-sm text-gray-600" }
const _hoisted_6 = {
  for: "file-upload",
  class: "relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Upload a file", -1)
const _hoisted_8 = ["accept"]
const _hoisted_9 = { class: "text-xs text-gray-500" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "flex flex-col" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "flex-1" }

import { useFulfilment } from "@/composables/fulfilment";
import { PropType } from "@vue/runtime-core";
import axios from "axios";
import { round } from "lodash";
import { ref } from "vue";
import Spinner from "@/components/Spinner.vue";
import { XIcon } from "@heroicons/vue/solid";

interface IFile {
  file: File;

  name?: string;
  mimetype?: string;
  size?: number;

  url?: string;
}


export default /*#__PURE__*/_defineComponent({
  props: {
  accept: String,
  prompt: String,

  modelValue: Array as PropType<{ name: string; size: number; file: File }[]>,
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props

const { client } = useFulfilment();



const files = ref([] as IFile[]);



const isUploading = ref(false);

const onFileChange = (fileEvent: any) => {
  let inputFiles = Array.from<any>(fileEvent.target.files).map(
    (file: File) => ({
      name: file.name,
      size: file.size,
      file,
    })
  );

  files.value = inputFiles;

  doFileUpload();

  emit("update:modelValue", [...files.value]);
};

const doFileUpload = async () => {
  console.log("Upload files...", { files });

  isUploading.value = true;

  try {
    let data = files.value.map((x) => x.file);

    let formData = new FormData();
    for (let file of data) formData.append("files[]", file);

    let response = await client.value!.post("/attachments/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    if (response.data?.files) {
      files.value = (response.data?.files as any[]).map((f: any, i) =>
        Object.assign({}, files.value[i] || {}, f)
      );

      console.log("Done upload.", { files });
    } else {
      throw "Invalid response.";
    }
  } catch (error: any) {
    console.error(error);
    if (error.response.data) {
      window.alert(JSON.stringify(error.response.data, null, 4));
    }
    files.value = [];
  } finally {
    isUploading.value = false;
    emit("update:modelValue", [...files.value]);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (files.value.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("label", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("input", {
                  id: "file-upload",
                  name: "file-upload",
                  type: "file",
                  class: "sr-only",
                  accept: __props.accept,
                  onChange: onFileChange,
                  multiple: ""
                }, null, 40, _hoisted_8)
              ])
            ]),
            _createElementVNode("p", _hoisted_9, _toDisplayString(__props.prompt), 1)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("ul", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, (file, i) => {
              return (_openBlock(), _createElementBlock("li", {
                key: file,
                class: _normalizeClass(["text-sm flex px-2 py-2 items-center rounded text-gray-600 group", !isUploading.value && 'hover:bg-gray-50 cursor-pointer']),
                onClick: ($event: any) => (isUploading.value ? null : files.value.splice(i, 1))
              }, [
                _createElementVNode("span", _hoisted_13, _toDisplayString(file.name), 1),
                (isUploading.value)
                  ? (_openBlock(), _createBlock(Spinner, {
                      key: 0,
                      class: "w-4 h-4 text-gray-500 ml-2"
                    }))
                  : (_openBlock(), _createBlock(_unref(XIcon), {
                      key: 1,
                      class: "w-4 h-4 text-gray-300 group-hover:text-red-500 ml-2"
                    }))
              ], 10, _hoisted_12))
            }), 128))
          ])
        ]))
  ]))
}
}

})